import { region } from '@/config/locales'
import { regionLazy } from './regionLazy'
import type { OnboardingPolicy } from './onboardingPolicy'
import { nlOnboarding } from './nl/onboarding/policy'
import { ukOnboarding } from './uk/onboarding'

const POLICIES: Record<typeof region, OnboardingPolicy> = {
  nl: nlOnboarding,
  uk: ukOnboarding,
}

export const onboardingPolicy: OnboardingPolicy = POLICIES[region]

// Rendered on /dashboard while the patient is not onboarded.
export const RegionOnboarding = regionLazy<object>({
  nl: () => import('./nl/onboarding/OnboardingScreen'),
  uk: () => import('./uk/OnboardingScreen'),
})
